import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";


function ModalValidateAll(props) {
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);

  async function handleValidateStorage(e) {
    e.preventDefault();
    let response;
    
      response = await api.put('/storage/validated/fornf/'+ props.props.nf, {
      });
      if (response.status === 200) {
        setControlSnack(true);
        props.onHide();
        props.loadStorage();
      
    }
  }

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
      break;
    }
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Aceitar todas as entradas
          </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleValidateStorage}>
        <Modal.Body>
        <h4> Tem certeza que deseja validar todas as entradas dessa nota fiscal?</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Validar
          </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Estques validados com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
        </Form>
    </Modal>
  );
}

export default ModalValidateAll;